export function cloudiTransform(url, transform) {
  let regex = /upload\//g;
  return url.replace(regex, `upload/${transform}`);
}

export function getClaudImage(url) {
  let regex = url.split(/([^\/]+$)/g);
  return regex[1];
}
